module.exports = __webpack_public_path__ + "static/img/news_tu1.381fdd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_tu1.png
// module id = xooe
// module chunks = 0